<template>
  <div class="indexAdminLogin_return" @click="closeToken">
    <div>
      <el-icon><ArrowLeft /></el-icon>
    </div>
  <div style="margin-top: -3px">
    <span>返回</span>
  </div>

  </div>
  <div class="indexAdminLogin_LoginInput_class_div_top">
    <el-image
        v-if="systemMetaBaseData.systemLogo !==null"
        :src="systemMetaBaseData.systemLogo.systemFileUrl"
        fit="fill"
    />

    <div class="indexAdminLogin_addLessee_title">
      更懂你的移动办公工具
    </div>
  </div>
  <div class="indexAdminLogin_AddLessee_code">
    <img src="@/assets/indexLogin_appDownload.png" alt="" >
  </div>
  <div class="indexAdminLogin_AddLessee_remake">下载千信云APP操作更便捷</div>
</template>

<script setup>
import {onMounted, reactive, defineExpose, defineEmits} from 'vue';
import {requestToken} from '@/util/adminRequest.js';
import store from '@/configure/store';
import router from "@/configure/router";

//系统基础数据
const systemMetaBaseData = store.state.systemMetaBaseData
// 返回上级调用参数
const emits = defineEmits(['childMethod'])
// 初始值
const showData = reactive({
  lesseeMainUserLesseeList: [], // 全部企业列表
});
//跳转到扫码登录
const closeToken = function () {
  emits('childMethod', 'closeLessee', "")
}
//切换公司（获取所在租户列表）
const listLesseeMainUserLessee = function () {
  // 获取数据
  requestToken({
    url: '/Api/userSystem/LesseeUserModule/LesseeUser/ListLesseeMainUserLessee',
    data: {}
  }).then(res => {
    showData.lesseeMainUserLesseeList = res.data
  })
}

// 启动调用
onMounted(() => {
});
//公开方法
defineExpose({listLesseeMainUserLessee});
</script>
<style scoped>
</style>
